
import { createSelector } from 'reselect'
import getHasSampledVariantDataSelector from 'modules/variant/redux/selectors/get-has-sampled-variant-data'

/**
 * @param {number} variantId
 * @returns {boolean}
 */
const wasLikedVariantSelector = variantId => createSelector(
  getHasSampledVariantDataSelector(variantId),
  (hasSampledData) => {
    return hasSampledData?.hasSampled === true && hasSampledData?.pssAnswer === 'like'
  }
)

export default wasLikedVariantSelector

/**
 * This selector is used to check if the variant is liked by the user or not.
 * It takes the variantId as a parameter and returns a boolean value.
 */
